import { render, staticRenderFns } from "./VoiceComposer.vue?vue&type=template&id=deb6f144&"
import script from "./VoiceComposer.vue?vue&type=script&lang=js&"
export * from "./VoiceComposer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports